import {
  debounce,
  isEmptyObject,
  formatMoney,
  formatMoneyCurrencyConversion,
  slugify,
} from './helpers';
import {
  addAllEventListeners,
  createTemplateElement,
  createElement,
  clearElement,
  getParamByName,
  isTouchDevice,
  isInIframe,
} from './DOMHelpers';
import ThemeSection from './models/ThemeSection';
import Variant from './models/Variant';
import Product from './models/Product';
import Collection from './models/Collection';
import Cart from './models/Cart';
import Customer from './models/Customer';
import Address from './models/Address';
import CartService from './services/cart/CartService';
import ProductService from './services/product/ProductService';
import CollectionService from './services/collection/CollectionService';
import ShippingService from './services/shipping/ShippingService';
import EventEmitter from './polyfills';

export {
  EventEmitter,
  debounce,
  isEmptyObject,
  formatMoney,
  formatMoneyCurrencyConversion,
  slugify,
  CartService,
  ProductService,
  CollectionService,
  ThemeSection,
  Variant,
  Product,
  Collection,
  Cart,
  Customer,
  Address,
  ShippingService,
  addAllEventListeners,
  clearElement,
  createElement,
  createTemplateElement,
  getParamByName,
  isTouchDevice,
  isInIframe,
};
